// Français (fr)

export const fr = {
  brand: { name: 'DoneLine', tagline: 'Gestionnaire de projets personnels' },
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    rename: 'Renommer',
    archive: 'Archiver',
    add: 'Ajouter',
    close: 'Fermer',
    edit: 'Modifier',
    new: 'Nouveau',
    yes: 'Oui',
    no: 'Non',
    back: 'Retour',
    next: 'Suivant',
    skip: 'Passer',
    done: 'Terminé',
    loading: 'Chargement…',
    sending: 'Envoi…',
    saving: 'Enregistrement…',
    untitled: 'Sans titre',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
    none: 'Aucun',
    optional: 'Facultatif',
    requiredField: 'Requis',
    confirmDelete: 'Supprimer ?',
  },
  nav: {
    today: "Aujourd'hui",
    upcoming: 'À venir',
    inbox: 'Boîte de réception',
    projects: 'Mes projets',
    tags: 'Étiquettes',
    reports: 'Rapport hebdo',
    settings: 'Paramètres',
    quickCapture: 'Capture rapide',
    search: 'Rechercher',
    newProject: 'Nouveau projet',
    addSection: 'Ajouter une section',
    openMenu: 'Ouvrir le menu',
  },
  search: {
    title: 'Rechercher',
    placeholder: 'Rechercher tâches, projets, étiquettes…',
    noResults: 'Aucun résultat',
    tasks: 'Tâches',
    projects: 'Projets',
    tags: 'Étiquettes',
  },
  today: {
    title: "Aujourd'hui",
    eyebrow: "Aujourd'hui",
    overdue: 'En retard',
    today: "Aujourd'hui",
    completed: 'Terminées',
    empty: "Rien à faire aujourd'hui. Respirez ☕",
    summary: '{active} en cours · {done} terminées',
    reschedule: 'Reprogrammer',
    rescheduled: '{count} tâche(s) reprogrammée(s)',
  },
  inbox: {
    title: 'Boîte de réception',
    eyebrow: 'Boîte de réception',
    empty: 'La boîte est vide.',
    pending: '{count} en attente',
  },
  upcoming: {
    title: 'À venir',
    eyebrow: 'Prochains 7 jours',
    todayLabel: "Aujourd'hui",
    tomorrowLabel: 'Demain',
    empty: 'Aucune tâche dans les 7 prochains jours.',
  },
  project: {
    eyebrow: 'Projet',
    notFound: 'Projet introuvable',
    notFoundHint: 'Il a peut-être été supprimé ou archivé.',
    inProgress: '{count} en cours',
    completed: '{count} terminées',
    ungrouped: 'Non classées',
    addSection: 'Ajouter une section',
    listView: 'Liste',
    ganttView: 'Gantt',
    ganttZoomIn: 'Zoom avant',
    ganttZoomOut: 'Zoom arrière',
    ganttWide: 'Large',
    ganttCompact: 'Compact',
    empty: 'Pas encore de tâche dans ce projet',
    emptyHint: 'Utilisez le champ ci-dessus pour en ajouter.',
    sectionEmpty: '— Aucune tâche —',
    completedSection: 'Terminées',
    newSectionTitle: 'Nouvelle section',
    newSectionPlaceholder: 'Nom de la section',
    renameProjectTitle: 'Renommer le projet',
    renameProjectPlaceholder: 'Nom du projet',
    editProjectTitle: 'Modifier le projet',
    color: 'Couleur',
    icon: 'Icône',
    noIcon: 'Aucune icône',
    deleteProjectTitle: 'Supprimer le projet « {name} » ?',
    deleteProjectDesc:
      'Les tâches de ce projet seront déplacées dans la Boîte. Action irréversible.',
    archiveProject: 'Archiver',
    actionsMenu: 'Actions du projet',
    renameSectionTitle: 'Renommer la section',
    sectionDeleteTitle: 'Supprimer la section « {name} » ?',
    sectionDeleteDesc:
      'Les tâches de cette section seront déplacées à la racine du projet. Cette action est irréversible.',
    sectionActionsMenu: 'Actions de section',
    sectionReorder: 'Réorganiser la section',
    descriptionPlaceholder: 'Ajouter une note sur ce projet…',
    descriptionEditHint: 'Markdown pris en charge · ⌘↵ enregistrer · Esc fermer',
    descriptionEmpty: 'Cliquer pour ajouter une note',
  },
  upgrade: {
    title: 'Passer à DoneLine Pro',
    featureLocked: '« {feature} » est une fonctionnalité Pro.',
    comingSoon: 'Pro arrive bientôt — votre compte sera prêt dès le lancement.',
    signInFirst: 'Se connecter pour passer à Pro',
    benefits: {
      unlimitedProjects: 'Projets illimités (gratuit : 3 max)',
      history: '365 jours d’historique des modifications (gratuit : 7 jours)',
      gantt: 'Vue Gantt',
      importExport: 'Import / export de vos données',
      themes: 'Plus de thèmes, dont Paper',
    },
    feature: {
      projects: 'Plus de 3 projets',
      gantt: 'Vue Gantt',
      importExport: 'Import / Export',
      paperTheme: 'Thèmes Pro',
    },
    cta: {
      stripe: 'S’abonner — 2,99 $/mois ou 29,99 $/an',
      apple: 'S’abonner via Apple',
      google: 'S’abonner via Google Play',
    },
  },
  plan: {
    title: 'Forfait',
    description: 'Votre niveau d’abonnement.',
    free: 'Gratuit',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Passer à Pro',
    devSwitchHint: 'Aperçu : changez temporairement de forfait pour tester les limites',
    switchToFree: 'Passer en Gratuit (aperçu)',
    switchToPro: 'Passer en Pro (aperçu)',
  },
  reports: {
    eyebrow: 'Rapport hebdo',
    title: 'Bilan des 7 derniers jours',
    serverGeneratedAt: 'Généré par le serveur à {time}',
    syncingFromServer: 'Synchronisation avec le serveur…',
    computedLocally: 'Calcul local',
    aiSummary: 'Résumé IA hebdo',
    completedCount: 'Terminées',
    completionRate: "Taux d'achèvement",
    overdueCount: 'En retard',
    dailyAverage: 'Moyenne / jour',
    dailyCompleted: 'Terminées par jour',
    dailyCompletedAxis: '(tâches)',
    byProject: 'Par projet',
    noCompletedThisWeek: 'Aucune tâche terminée cette semaine.',
    serverNotReady:
      "Le serveur n'a pas encore généré le rapport de cette semaine. Le batch worker s'exécute chaque lundi à 09:00 dans votre fuseau horaire.",
  },
  settings: {
    display: {
      title: 'Affichage',
      description: 'Choisissez les détails affichés dans les listes.',
      tags: 'Étiquettes',
      tagsHint: 'Afficher les étiquettes sur les lignes',
      descriptionLabel: 'Description',
      descriptionHint: "Afficher un aperçu d'une ligne",
      subtasks: 'Sous-tâches',
      subtasksHint: 'Afficher la progression des sous-tâches',
    },
    eyebrow: 'Paramètres',
    title: 'Préférences',
    appearance: { title: 'Apparence', description: 'Choisissez le thème adapté au moment.' },
    language: { title: 'Langue', description: "Langue d'affichage des menus et libellés." },
    desktop: {
      title: 'Bureau',
      description:
        'Comportement natif macOS / Windows / Linux. Actif uniquement dans l’application de bureau.',
      alwaysOnTopLabel: 'Toujours au premier plan',
      alwaysOnTopHint:
        'Maintient la fenêtre au-dessus de toutes les autres apps jusqu’à désactivation.',
      globalHotkeyLabel: 'Raccourci global de capture rapide',
      globalHotkeyHint:
        '⌘⇧Espace système — ouvre DoneLine et place le focus sur le champ de capture depuis n’importe où.',
    },
    account: {
      title: 'Compte',
      description: 'Informations de connexion et résumé.',
      summary: '{tasks} tâches · {projects} projets',
      signOut: 'Se déconnecter',
      deleteAccount: 'Supprimer le compte',
      deleteAccountConfirmTitle: 'Supprimer le compte ?',
      deleteAccountConfirmBody:
        'Cette action supprime définitivement votre compte ainsi que toutes vos tâches, projets et étiquettes, sur nos serveurs comme dans ce navigateur. Elle est irréversible. Exportez vos données au préalable si vous souhaitez les conserver.',
      deleteAccountConfirm: 'Supprimer',
      deleteAccountFailed: 'Impossible de supprimer le compte',
      signingOut: 'Déconnexion…',
      notSignedIn: 'Non connecté',
      signInCta: 'Se connecter',
      guestHint:
        'Mode invité : les données restent sur cet appareil. Connectez-vous pour activer la synchro et la sauvegarde.',
      displayNameLabel: 'Nom d’affichage',
      displayNamePlaceholder: 'Votre nom',
      displayNameSaved: 'Enregistré',
      displayNameSaveFailed: 'Échec de l’enregistrement',
      avatarLabel: 'Avatar',
      avatarHint: "JPG, PNG, WEBP ou GIF, jusqu'à 2 Mo. Vide affiche l'initiale.",
      avatarUpload: 'Charger une image',
      avatarChange: "Changer l'image",
      avatarUploading: 'Envoi…',
      avatarRemove: 'Retirer',
      avatarSaved: 'Avatar mis à jour',
      avatarSaveFailed: "Échec de la mise à jour de l'avatar",
      avatarErrorType: 'Format non pris en charge. Utilisez JPG, PNG, WEBP ou GIF.',
      avatarErrorSize: 'Image trop volumineuse. Max 2 Mo.',
    },
    sync: {
      title: 'Synchronisation',
      description: 'Lancer une synchronisation incrémentale complète maintenant.',
      forceSync: 'Synchroniser maintenant',
      syncing: 'Synchronisation…',
      done: 'Synchronisation terminée',
    },
    shortcuts: {
      title: 'Raccourcis clavier',
      description: 'Le clavier est le pointeur le plus rapide.',
      view: 'Voir les raccourcis',
    },
    data: {
      title: 'Données',
      description: 'Toutes les données sont stockées localement puis synchronisées.',
      export: 'Exporter JSON',
      import: 'Importer JSON',
      exportDone: '{n} tâches exportées',
      importDone: '{n} nouveaux éléments importés',
      importError: 'Échec import : {error}',
      importPersistFailed:
        "L'importation n'a pas pu être enregistrée dans le stockage local : les données dépassent peut-être la limite de l'appareil. Importez par lots plus petits.",
      clearAll: 'Effacer les données locales',
      clearConfirmTitle: 'Effacer toutes les données locales ?',
      clearConfirmDesc:
        'Cela supprime tout ce qui est stocké dans ce navigateur. Les données synchronisées sur le serveur ne sont pas affectées. La page sera rechargée.',
      cleared: 'Effacé. Rechargement…',
    },
    about: {
      title: 'À propos',
      version: 'Version {v}',
      description: 'Un gestionnaire de tâches et de projets personnel inspiré de la méthode GTD.',
    },
  },
  guest: {
    banner: 'Mode invité — les données restent sur cet appareil. Connectez-vous pour synchroniser.',
    bannerCta: 'Se connecter',
    emptyHint:
      "Tant que vous n'êtes pas connecté, vos données restent sur cet appareil. Ajoutez votre première tâche ci-dessous.",
    storageWarning:
      'Les données invité ne vivent que dans ce navigateur et peuvent être effacées par le système. Connectez-vous ou exportez régulièrement (les exports ne sont pas chiffrés).',
  },
  login: {
    welcomeBack: 'Bon retour',
    helperSupabase: 'Entrez votre email pour recevoir un lien de connexion à usage unique.',
    helperLocal:
      "Mode local : entrez n'importe quel email pour vous connecter immédiatement (Supabase non configuré).",
    emailPlaceholder: 'vous@exemple.com',
    sendLink: 'Envoyer le lien',
    sendingLink: 'Envoi…',
    sentSupabase: 'Envoyé à {email}. Cliquez sur le lien dans votre boîte mail.',
    otpPrompt: 'Ou saisissez le code reçu par e-mail',
    otpPlaceholder: 'Code à 6 chiffres',
    otpSubmit: 'Se connecter',
    otpFailed: 'Ce code est invalide ou a expiré',
    sentLocal: 'Connecté en tant que {email}. Chargement…',
    modeSupabase: 'Supabase Auth',
    modeLocal: 'Mode Mock local (backend non configuré)',
    skipGuest: 'Passer — utiliser en local',
    skipFailed:
      "Impossible d'activer le mode invité (échec du stockage local). Veuillez réessayer.",
    merge: {
      title: 'Cet appareil contient {count} tâches',
      keep: 'Les fusionner avec mon compte',
      irreversible: 'Elles seront envoyées après connexion. La fusion est irréversible.',
      discard: 'Ne pas conserver les données locales',
      discardConfirmTitle: 'Après connexion, {count} tâches locales seront supprimées',
      discardConfirmBody:
        'Une fois la connexion terminée, les {count} tâches de cet appareil seront définitivement supprimées et irrécupérables. Continuer ?',
    },
    error: 'Échec de connexion',
  },
  task: {
    recurringAdvanced: 'Répétition — déplacée au {date}',
    recurringFinished: 'Répétition terminée — tâche accomplie',
    titlePlaceholder: 'Titre de la tâche',
    description: 'Description',
    descriptionPlaceholder: 'Ajouter une description…',
    descriptionEmpty: 'Aucune description.',
    descriptionEdit: 'Modifier la description',
    descriptionSave: 'Enregistrer la description',
    descriptionCancel: 'Annuler',
    save: 'Enregistrer',
    saved: 'Enregistré',
    discardConfirmTitle: 'Abandonner les modifications non enregistrées ?',
    discardConfirmDesc:
      'Vous avez des modifications non enregistrées. Si vous fermez maintenant, elles seront perdues.',
    priority: 'Priorité',
    date: 'Date',
    project: 'Projet',
    section: 'Section',
    parentTask: 'Tâche parente',
    tags: 'Étiquettes',
    subtasks: 'Sous-tâches',
    expandSubtasks: 'Afficher les sous-tâches',
    collapseSubtasks: 'Masquer les sous-tâches',
    addSubtaskPlaceholder: '+ Ajouter une sous-tâche',
    comments: 'Commentaires',
    noComments: 'Aucun commentaire',
    commentPlaceholder: 'Écrire un commentaire…',
    sendComment: 'Envoyer',
    delete: 'Supprimer',
    deleteConfirmTitle: 'Supprimer cette tâche ?',
    deleteConfirmDesc: 'Les sous-tâches seront aussi supprimées.',
    saveHint: '⌘/Ctrl + Enter pour enregistrer et fermer',
    open: 'Ouvrir',
    completed: 'Terminée',
    markComplete: 'Marquer comme terminée',
    markIncomplete: 'Marquer comme non terminée',
    moreActions: 'Plus d’actions',
  },
  priority: {
    high: 'Haute',
    mid: 'Moyenne',
    low: 'Basse',
    none: 'Aucune',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: 'Jour',
      datetime: 'Heure',
      range: 'Plage',
      today: "Aujourd'hui",
      tomorrow: 'Demain',
      thisWeekend: 'Ce week-end',
      nextWeek: 'Semaine prochaine',
      noDate: 'Sans date',
    },
    overdue: 'En retard',
    notScheduled: 'Sans date',
  },
  recurrence: {
    title: 'Répéter',
    none: 'Ne se répète pas',
    custom: 'Personnalisé…',
    applyCustom: 'Appliquer la règle personnalisée',
    end: 'Fin de la répétition',
    preset: {
      daily: 'Tous les jours',
      weekdays: 'Chaque jour de semaine',
      weekly: 'Chaque semaine',
      biweekly: 'Toutes les 2 semaines',
      monthly: 'Chaque mois',
      yearly: 'Chaque année',
    },
    summary: {
      daily: 'Tous les jours',
      everyNDays: 'Tous les {n} jours',
      weekly: 'Chaque semaine',
      everyNWeeks: 'Toutes les {n} semaines',
      weeklyOn: 'Chaque semaine, le {days}',
      everyNWeeksOn: 'Toutes les {n} semaines, le {days}',
      monthly: 'Chaque mois',
      everyNMonths: 'Tous les {n} mois',
      yearly: 'Chaque année',
      everyNYears: 'Tous les {n} ans',
    },
    weekday: { sun: 'Dim', mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Jeu', fri: 'Ven', sat: 'Sam' },
    freq: { daily: 'Jour(s)', weekly: 'Semaine(s)', monthly: 'Mois', yearly: 'An(s)' },
    every: 'Tous les',
  },
  aiUsage: {
    title: 'Utilisation IA',
    planFree: 'Offre gratuite',
    planPro: 'Offre Pro',
    planProAi: 'Offre Pro AI',
    usedOf: '{used} / {limit} ce mois-ci',
    remaining: 'Restant : {count}',
    resetsMonthly: 'Réinitialisé le 1er de chaque mois (UTC)',
    history: 'Activité récente',
    historyEmpty: 'Aucune utilisation IA pour le moment',
    endpointParse: 'Analyse IA',
    endpointBreakdown: 'Découpage IA',
    signInFirst: 'Connectez-vous pour voir votre utilisation',
    loadFailed: 'Échec du chargement',
    retry: 'Réessayer',
  },
  parseTask: {
    mode: 'IA',
    quickMode: 'Rapide',
    title: 'Analyse de tâche par IA',
    placeholder: 'Décrivez une tâche avec vos mots…',
    titlePlaceholder: 'Titre de la tâche',
    hint: 'L’IA remplit date, priorité, projet et étiquettes',
    parse: 'Analyser',
    confirm: 'Ajouter la tâche',
    confirmMany: 'Ajouter {count} tâches',
    back: 'Retour',
    voice: 'Saisie vocale',
    voiceDenied: 'Autorisation du microphone refusée',
    voiceUnavailable: 'Saisie vocale non prise en charge par ce navigateur',
    errors: {
      rateLimited: 'Trop de requêtes — réessayez dans un instant',
      monthlyLimit: 'Quota IA mensuel épuisé — passez à une offre supérieure',
      unauthorized: 'Connectez-vous pour utiliser l’IA',
      unavailable: 'L’IA est actuellement indisponible',
      failed: 'Impossible d’analyser la tâche — reformulez',
    },
  },
  quickCapture: {
    placeholder: 'Ajouter une tâche… (Entrée pour enregistrer)',
    hint: 'Essayez : « Acheter du lait tomorrow @vie #rapide p2 »',
    newTag: '#{name} (nouveau)',
    dismissMatch: 'Garder « {label} » comme texte',
    createTag: "Créer l'étiquette « {name} »",
    syntaxCheatsheet: 'today / tomorrow / next mon · @projet[/section] · #étiquette · p1-p4',
    add: 'Ajouter',
    open: 'Ouvrir la capture rapide',
    addTask: 'Ajouter une tâche',
  },
  tag: {
    eyebrow: 'Étiquette',
    editTagTitle: "Modifier l'étiquette",
    renameTagPlaceholder: "Nom de l'étiquette",
    newTagPlaceholder: 'Nouvelle étiquette…',
    deleteTagTitle: "Supprimer l'étiquette « {name} » ?",
    deleteTagDesc: 'Elle sera retirée de {count} tâche(s). Irréversible.',
    actionsMenu: "Actions d'étiquette",
    nameTaken: 'Une étiquette de ce nom existe déjà',
    empty: 'Aucune tâche avec cette étiquette',
  },
  quickbar: {
    signInRequired: 'Connexion requise',
    signInHint: 'Connectez-vous d’abord pour capturer des tâches depuis la barre des menus.',
    signInOpenMain: 'Ouvrez la fenêtre principale de DoneLine pour vous connecter',
  },
  sync: {
    idle: 'Synchronisé',
    syncing: 'Synchronisation',
    offline: 'Hors ligne',
    error: 'Échec de sync',
    disabled: 'Mode local',
    pending: '{count} en attente',
    syncingPending: 'Sync · {count} en attente',
    offlinePending: 'Hors ligne · {count} en attente',
    authError: "Échec d'authentification — veuillez vous reconnecter",
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: 'Cliquer pour réessayer',
  },
  commandPalette: {
    placeholder: 'Rechercher des tâches, aller à une vue ou exécuter une action…',
    empty: 'Aucun résultat.',
    tasks: 'Tâches',
    projects: 'Projets',
    navigation: 'Navigation',
    actions: 'Actions',
  },
  bulk: {
    toolbar: 'Actions groupées',
    selected: '{count} sélectionnées',
    clear: 'Effacer',
    deleteTitle: 'Supprimer {count} tâche(s) ?',
    deleteDesc: 'Les sous-tâches seront également supprimées. Action irréversible.',
    mixedProjects: 'Projets multiples',
  },
  shortcuts: {
    title: 'Raccourcis clavier',
    quickAdd: 'Capture rapide',
    search: 'Rechercher',
    help: 'Afficher ce panneau',
    gotoToday: "Aller à Aujourd'hui",
    gotoInbox: 'Aller à la Boîte',
    gotoUpcoming: 'Aller à À venir',
    drawer: {
      title: 'Dans le détail de tâche',
      saveClose: 'Enregistrer et fermer',
      delete: 'Supprimer la tâche',
      priorityKeys: 'Définir la priorité (1=Haute … 4=Aucune)',
    },
  },
  welcome: {
    title: 'Bienvenue dans {brand}',
    subtitle: 'Lancez-vous en 30 secondes.',
    step1: {
      title: "Capturez n'importe quoi en 1 seconde",
      body: "Appuyez sur Q n'importe où pour ouvrir la capture rapide. Tapez une tâche et appuyez sur Entrée — elle file dans votre Boîte.",
    },
    step2: {
      title: 'Organisez quand vous le pouvez',
      body: 'Glissez-déposez les tâches dans Projets et Sections. La date, la priorité ou les étiquettes peuvent attendre.',
    },
    step3: {
      title: 'Planifiez votre journée',
      body: "La vue Aujourd'hui rassemble automatiquement les tâches du jour et les plages de dates couvrant aujourd'hui.",
    },
    step4: {
      title: 'Prêt',
      body: "Nous avons ajouté quelques tâches d'introduction pour vous aider à explorer. Marquez-les comme faites ou supprimez-les.",
    },
    getStarted: 'Commencer',
  },
  onboarding: {
    project: { welcome: 'Bienvenue', learn: 'Apprendre' },
    tasks: {
      welcome: '👋 Bienvenue dans {brand} !',
      welcomeDesc:
        "Cliquez sur la case à gauche pour la marquer comme faite. C'est ainsi qu'on termine une tâche.",
      quickAdd: '⚡ Essayez la capture rapide : appuyez sur Q ou le bouton en haut à gauche',
      quickAddDesc:
        'Tapez le titre et appuyez sur Entrée. @projet pour assigner, #étiquette pour étiqueter, p1-p4 pour la priorité.',
      organize: '📁 Regroupez les tâches dans des Projets',
      organizeDesc:
        'Cliquez « + Nouveau projet » dans la barre latérale. Glissez les tâches dedans.',
      schedule: '🗓 Définissez une date pour planifier',
      scheduleDesc:
        "Les tâches du jour apparaissent automatiquement dans la vue Aujourd'hui. Ouvrez cette tâche et donnez-lui une échéance.",
      priority: '🔥 Utilisez les priorités (P1=Haute, P4=Aucune)',
      priorityDesc: 'Appuyez sur 1 / 2 / 3 / 4 dans le détail pour définir la priorité.',
      drag: '✋ Glissez pour réordonner',
      dragDesc: 'Survolez une tâche, une poignée apparaît à gauche. Saisissez-la pour la déplacer.',
      gantt: '📊 Visualisez avec le Gantt',
      ganttDesc:
        "Ouvrez un projet et passez à l'onglet « Gantt » pour voir les tâches sur une chronologie.",
      reports: '📈 Faites le bilan avec le Rapport hebdo',
      reportsDesc: 'Voyez chaque semaine ce que vous avez terminé et ce qui a été reporté.',
      finishMe: '✅ Cochez cette liste — vous êtes prêt !',
    },
  },
  errors: {
    networkError: 'Erreur réseau',
    unknownError: 'Erreur inconnue',
    notFound: 'Introuvable',
    pageNotFound: 'Page introuvable',
    pageNotFoundDesc: "Cette URL n'existe pas ou a été déplacée.",
    backHome: "Retour à Aujourd'hui",
    somethingWrong: 'Une erreur est survenue',
    tryAgain: 'Réessayer',
    goHome: "Retour à l'accueil",
  },
  theme: {
    light: 'Clair',
    dark: 'Sombre',
    paper: 'Papier',
    rose: 'Rose',
    lavender: 'Lavande',
    peach: 'Pêche',
    mauve: 'Mauve',
    slate: 'Ardoise',
    forest: 'Forêt',
    midnight: 'Minuit',
    shiba: 'Shiba',
    cat: 'Chat',
    ocean: 'Océan',
    sky: 'Ciel',
    mint: 'Menthe',
    matcha: 'Matcha',
    amber: 'Ambre',
    mocha: 'Moka',
    crimson: 'Cramoisi',
    nord: 'Nord',
    dracula: 'Dracula',
    graphite: 'Graphite',
    system: 'Système',
    pickerTitle: 'Thème',
  },
} as const;
